import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=24581cb8&scoped=true&"
import script from "./ClassList.vue?vue&type=script&lang=js&"
export * from "./ClassList.vue?vue&type=script&lang=js&"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=24581cb8&lang=scss&scoped=true&"
import style1 from "./ClassList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24581cb8",
  null
  
)

export default component.exports